module.exports = __webpack_public_path__ + "img/about-辅导项目-执业药师类.394d2503.jpg";